import { cx } from '../../utils/cx';
import s from './Spinner.module.css';

export type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  /** Screen-reader text. Pass `null` when a parent already announces the busy state. */
  label?: string | null;
  className?: string;
};

export function Spinner({ size = 'md', label = 'Loading', className }: SpinnerProps) {
  return (
    <span
      className={cx(s.spinner, className)}
      data-size={size}
      role={label ? 'status' : undefined}
      aria-label={label ?? undefined}
      aria-hidden={label ? undefined : true}
    />
  );
}
